import styled from 'styled-components';
import { Button } from './Button';
import { Colors } from '../../constants/colors';
import { rgba } from 'polished';

export const IconButton = styled(Button)`
  color: ${Colors.primary};
  border: none;
  background: transparent;
  padding: 0;
  width: 50px;
  height: 50px;
  border-radius: 0;

  justify-content: center;
  align-items: center;

  :hover {
    background: ${rgba(Colors.primary, 0.05)} !important;
  }

  svg {
    margin-left: 0;
  }

`;
